import { defineRecipe } from '@chakra-ui/react';

export const textRecipe = defineRecipe({
  base: {
    color: 'black',
    fontWeight: 400,
    fontFamily: 'Roboto, sans-serif',
    marginTop: '0px',
  },
  variants: {
    size: {
      md: {
        fontSize: '15px',
        letterSpacing: '0.15px',
      },
      sm: {
        fontSize: '11px',
        letterSpacing: '0.11px',
      },
    },
    lh: {
      normal: {
        lineHeight: '20px',
      },
      high: {
        lineHeight: '23px',
      },
    },
    variant: {
      inline: {
        marginBottom: '0px',
      },
      paragraph: {
        marginBottom: '8px',
      },
    },
  },
  defaultVariants: {
    lh: 'normal',
    size: 'md',
    variant: 'paragraph',
  },
});
